import React, { useState } from "react";
import DSInput from "@/componentsDS/Input";
import DSInputDropdown from "@/componentsDS/InputDropdown";
import { validateDomain, validateEmail } from "@/utils/validate-email";
import validateMobile from "@/utils/validate-mobile";
import { getEnvAndDex } from "@/utils/get-env-and-dex";
import PropTypes from "prop-types";
import { Controller } from 'react-hook-form'

const Appointment = ({
	errors,
	register,
	infoItems,
	countryCodes,
	appointmentInfo,
	setAppointmentInfo,
	setValue,
	control,
	allowAppointmentToggle,
	showAppointmentSelection,
	isFilledWithMyInfo,
	currentProfile,
	watch
}) => {

	const { dex } = getEnvAndDex();
	const [nationality, setNationality] = useState("");
	const [appointmentTitle, setAppointmentTitle] = useState("");
	const {appointmentName, appointmentEmail, appointmentMobileNo} = watch(["appointmentName", "appointmentEmail", "appointmentMobileNo"])

	return (
		<>
			<div className="login-box__section-title-buildex">
				Appointments{" "}
				{allowAppointmentToggle && (
					<span
						className="login-box-appointment__heading"
						onClick={showAppointmentSelection}
						role="none"
					>
						(Change)
					</span>
				)}
			</div>

			<div className="login-box__form__cols--buildex">
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="appointmentName"
						label="Name"
						placeholder="Enter Name"
						errorMessage={errors.appointmentName?.message}
						id="appointment-input"
						fullWidth={true}
						setValue={setValue}
						disabled={isFilledWithMyInfo}
						value={appointmentName}
						register={register({
							required: false,
						})}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half login-box-buildex__dropdown">
					<Controller
						name="nationality"
						control={control}
						render={({ onChange: controllerOnChange }) => {
							return (
								<DSInputDropdown
									name="nationality"
									label="Nationality"
									placeholder="Select Option"
									errorMessage={errors.nationality?.message}
									id="nationality"
									dropdownOption={
										infoItems?.nationality ?? []
									}
									size="default"
									fullWidth={true}
									value={currentProfile.organization.nationality?.desc ?? nationality}
									onChange={setNationality}
									disabled={isFilledWithMyInfo}
									onSelectDropdownItem={(item) =>
										controllerOnChange(item[0]?.id)
									}
								/>
							);
						}}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="appointmentEmail"
						label="Email Address"
						placeholder="Email"
						errorMessage={errors.appointmentEmail?.message}
						id="appointment-email"
						fullWidth={true}
						required={false}
						setValue={setValue}
						disabled={isFilledWithMyInfo && currentProfile?.organization?.appointmentEmail}
						value={appointmentEmail}
						register={register({
							required: false,
							validate: {
								checkEmail: (v) =>
									!v || validateEmail(v) ||
									"Please enter a valid company email address",
								checkDomain: (v) =>
									!v || validateDomain(v, dex) ||
									"The following domain are not allowed to be registered",
							},
						})}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half login-box-buildex__dropdown">
					<DSInput
						name="appointmentMobileNo"
						label="Mobile Number"
						placeholder="Enter number"
						errorMessage={errors.appointmentMobileNo?.message}
						required={false}
						id="appointment-mobile-no-input"
						type="number"
						fullWidth={true}
						setValue={setValue}
						value={appointmentMobileNo}
						disabled={isFilledWithMyInfo && currentProfile?.organization?.appointmentMobile}
						register={register({
							required: false,
							minLength: {
								value: 6,
								message:
									"Please enter valid mobile number ranging between 6-15 digits",
							},
							maxLength: {
								value: 15,
								message:
									"Please enter valid mobile number ranging between 6-15 digits",
							},
							validate: {
								checkMobileNumber: (v) =>
									validateMobile(v) ||
									"Please enter a valid number",
							},
						})}
						prefixDropdown={true}
						prefixDropdownOption={countryCodes}
						prefixDropdownSelectedOption={[
							{ id: appointmentInfo.mobileCountryCode.id },
						]}
						prefixDropdownOnAdd={(item) =>
							setAppointmentInfo((prev) => ({
								...prev,
								mobileCountryCode: item[0],
							}))
						}
						prefixDropdownValue={appointmentInfo.mobileCountryCode.cc}
					/>
				</div>
				<div className="login-box__form__col login-box-buildex__dropdown">
					<Controller
						control={control}
						name="appointmentTitle"
						render={({ onChange: controllerOnChange }) => {
							return (
								<DSInputDropdown
									name="appointmentTitle"
									label="Appointment Title"
									placeholder="Enter Company name"
									errorMessage={
										errors.appointmentTitle?.message
									}
									id="appointment-title"
									dropdownOption={
										infoItems?.appointmentTitle ?? []
									}
									fullWidth={true}
									value={currentProfile.organization.appointmentTitle?.desc ?? appointmentTitle}
									onChange={setAppointmentTitle}
									disabled={isFilledWithMyInfo}
									onSelectDropdownItem={(item) => {
										controllerOnChange(item[0]?.id);
									}}
								/>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
}

export default Appointment;

Appointment.propTypes = {
	errors: PropTypes.object,
	register: PropTypes.func,
	infoItems: PropTypes.object,
	countryCodes: PropTypes.array,
	appointmentInfo: PropTypes.object,
	setAppointmentInfo: PropTypes.func,
	setValue: PropTypes.func,
	control: PropTypes.object,
	allowAppointmentToggle: PropTypes.bool,
	showAppointmentSelection: PropTypes.func,
	isFilledWithMyInfo: PropTypes.bool,
	currentProfile: PropTypes.object,
	watch: PropTypes.func,
}
